export const STAGES = {
    "Call": "#00C8F4",
    "Follow up": "#0088AC",
    "Appt": "#008EA8",
    "25%": "#008E79",
    "50%": "#318843",
    "75%": "#717D11",
    "Won": "#468015",
    "Lost": "#C34A36",
    "default": "#A16807"
}

export const STATUS = {
    "Done": "#20c933",
    "Pending": "#fcb400",
    "Confirm": "#2d7ff9",
    "Call": "#f82b60",
}

export const PAYMENT_STATUS = {
    "Fully paid": "#20c933",
    "Partially paid": "#fcb400",
    "Instalment": "#2d7ff9",
}

export const PAYMENT_MODE = {
    "Instalment - 3 Months": "#c89595",
    "Instalment - 6 Months": "#f99de2",
    "Instalment - 9 Months": "#ff08c2",
    "Instalment - 12 Months": "#ba1e45",
    "Unlimited Instalment": "#20c933",
}

export const PAYMENT_METHOD = {
    "Cash": "#73b55c",
    "Cheque": "#a56bff",
    "Credit Card": "#008f6d",
    "PayNow": "#ff0042"
}

export const JOB = {
    "Site Survey": "#ffffff",
    "Installation": "#ffffff",
    "Change Filter": "#ffffff",
    "Repair": "#ffffff",
    "Delivery": "#ffffff",
    "Re-install": "#ffffff",
    "Servicing": "#ffffff",
    "Relocating": "#ffffff",
}

export const SOURCE = {
    "Facebook": "#ffffff",
    "Google": "#ffffff",
    "Walk in": "#ffffff",
    "Referral": "#ffffff",
    "Interior Designer": "#ffffff",
    "Roadshow 1": "#ffffff",
    "Roadshow 2": "#ffffff",
    "Roadshow 3": "#ffffff",
}

export const REMARKS_TYPES = {
    "Sales": "#20639B",
    "Maintenance": "#F6885C",
    "Payment": "#ED553B"
}

export const SERVICE_DURATION = {
    "3 months": "#ffffff",
    "6 months": "#ffffff",
    "9 months": "#ffffff",
    "12 months": "#ffffff"
}

const SELECTIONS = {
    STAGES,
    STATUS,
    JOB,
    PAYMENT_STATUS,
    PAYMENT_MODE,
    PAYMENT_METHOD,
    SOURCE,
    REMARKS_TYPES,
    SERVICE_DURATION
}

export default SELECTIONS